export default "__VITE_ASSET__62c45b2b__"